import { trans } from '@spotahome/soyuz/client';

import { BILLS_INCLUDED_VALUES } from '../tenant/constants';

import BestChoiceLabelIcon from '../tenant/components/icons/BestChoiceLabelIcon';
import PlusLabelIcon from '../tenant/components/icons/PlusLabelIcon';
import { DSIcon } from '../base';

export const getListingChips = (
  isDepositExempt,
  isInstantBooking,
  bills,
  isBestChoice,
  isPlus,
  isLongTerm,
  verifiedLandlord
) => {
  const chips = [];

  if (isDepositExempt) {
    chips.push({
      id: 'noDeposit',
      label: `${trans('homecard.label.no_deposit')}`,
      tooltip: `${trans('tooltip.message.no-deposit')}`,
      renderLeadingIcon: () => <DSIcon name="savings" size="sm" />
    });
  }

  if (!isDepositExempt) {
    chips.push({
      id: 'depositProtected',
      label: trans('homecard.label.deposit.protected'),
      renderLeadingIcon: () => <DSIcon name="lock_closed" size="sm" />
    });
  }

  if (verifiedLandlord) {
    chips.push({
      id: 'verifiedLandlord',
      label: trans('listing.landlord_info.verified_landlord'),
      renderLeadingIcon: () => (
        <DSIcon name="check_circle_transparent" size="sm" />
      )
    });
  }

  if (isInstantBooking) {
    chips.push({
      id: 'instantBooking',
      label: trans('homecard.label.instant'),
      renderLeadingIcon: () => <DSIcon name="electricity_bill" size="sm" />
    });
  }

  if (bills !== BILLS_INCLUDED_VALUES.none) {
    chips.push({
      id: 'billsIncluded',
      label:
        BILLS_INCLUDED_VALUES.all === bills
          ? trans('homecard.bills.included')
          : trans('homecard.bills.some-included'),
      renderLeadingIcon: () => <DSIcon name="euro" size="sm" />
    });
  }

  if (isBestChoice) {
    chips.push({
      id: 'bestChoice',
      label: trans('homecard.label.best-choice'),
      tooltip: trans('homecard.label.best-choice.tooltip'),
      renderLeadingIcon: () => <BestChoiceLabelIcon size="20" />
    });
  }

  if (isPlus) {
    chips.push({
      id: 'plus',
      label: 'Spotahome PLUS',
      renderLeadingIcon: () => <PlusLabelIcon size="20" />
    });
  }

  if (isLongTerm) {
    chips.push({
      id: 'longTerm',
      label: trans('homecard.label.long-term'),
      renderLeadingIcon: () => <DSIcon name="calendar_month" size="sm" />
    });
  }

  return chips.map(chip => ({
    ...chip,
    isSpaced: true,
    label: chip?.keepLabelCase ? chip.label : chip.label.toUpperCase()
  }));
};

const MAIN_BILLS = {
  Electricity: 5000,
  Water: 5001,
  Gas: 5002,
  Wifi: 5003
};

const includeNaFeatures = bill => (bill === 'na' ? true : bill);

export const isAllBillsIncluded = (bills = {}) =>
  Object.keys(MAIN_BILLS).every(billId =>
    includeNaFeatures(bills[MAIN_BILLS[billId]])
  );

export const isSomeBillsIncluded = (bills = {}) =>
  Object.keys(MAIN_BILLS).some(billId => bills[MAIN_BILLS[billId]] === true);

export const getBillsIncluded = bills => {
  if (isAllBillsIncluded(bills)) {
    return BILLS_INCLUDED_VALUES.all;
  }
  if (isSomeBillsIncluded(bills)) {
    return BILLS_INCLUDED_VALUES.some;
  }

  return BILLS_INCLUDED_VALUES.none;
};
